var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lawlex-custom-card"},[_vm._v(" "+_vm._s(_vm.$t('msg_something_went_wrong'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }